export const ON_BOARDING = "ON_BOARDING";
export const API_URL = process.env.REACT_APP_API_URL;
export const USER_SERVICE = `${API_URL}/user-service/`;
export const LIBRARY_SERVICE = `${API_URL}/library-service/`;
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URL;
export const USERPLAN_SERVICE = `${API_URL}/userplan-service/`;
export const NOTIFICATION_SERVICE = `${API_URL}/notification-service/`;
export const RECOMMENDATION_SERVICE = `${API_URL}/recommendation-service/`;
export const GATEWAY_SERVICE = `${API_URL}/gateway-service/`;

export const TOKEN_URL = process.env.REACT_APP_TOKEN_URL;
export const LOGIN_URL = `${process.env.REACT_APP_LOGIN_URL}=${REDIRECT_URI}`;

const encodedURL = `${encodeURIComponent(LOGIN_URL)}`;
export const LOGOUT_LOGIN_URL = `${process.env.REACT_APP_LOGOUT_URL}=${encodedURL}`;
export const tableauURL = process.env.REACT_APP_TABLEAU_URL;
